import { styled } from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';

export const ContentRow = styled.a`
  border-radius: 8px;
  min-height: 120px;
  cursor: pointer;
  background: linear-gradient(243deg, #27262b 43.77%, #ff6900 220.99%), #1b1b5d;
  flex-basis: 30%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  color: #fff;
  text-align: center;
  text-shadow: 0px 1.5px 1.5px rgba(11, 21, 46, 0.5);
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 23.4px */
  position: relative;
  @media (max-width: 768px) {
    border-radius: 8px;
    min-width: 100px;
    min-height: 80px;
    font-size: 12px;
  }

  ${({ $isActive }) =>
    $isActive &&
    `
      background: #3D3C41;
  `}
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
      opacity:0.4;
      cursor: not-allowed;
  `}
`;

export const ContentRows = styled.div`
  ${WRAPPER};
  display: flex;
  margin-top: 32px;
  margin-bottom: 32px;

  gap: 12px;
  flex: none;
  width: 100%;
  a {
    flex: 1;
  }
  @media (max-width: 768px) {
    gap: 8px;
    margin: 0;
    margin-top: 0;
    padding: 24px 0 12px 0;
    overflow: scroll;
    scroll-behavior: smooth;

    a:first-child {
      margin-left: 18px;
    }
    a:last-child {
      margin-right: 18px;
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CounterBlock = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  background-color: #dd3636;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -4px;
  right: -4px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`;
